/**
 * Global top bar — role switch only.
 *
 * Office/admin users get the v3 two-row global toolbar (TOOLBAR-SPEC.md,
 * mockups/toolbar-v3.html); field technicians keep their stripped-down bar.
 * The previous OfficeTopBar (pinned control strip + Work Pulse + right-cluster
 * utilities) has been fully retired in favor of v3.
 */
import { useAuth } from "@/lib/auth";
import { FieldTopBar } from "./field-top-bar";
import { TopBarV3 } from "./top-bar-v3";

export function TopBar() {
    const { isAdmin, isOffice, isField } = useAuth();

    // Field technicians get a stripped-down nav focused on their work only.
    if (isField && !isOffice && !isAdmin) {
        return <FieldTopBar />;
    }

    return <TopBarV3 />;
}
